(function () {
  var cartUrl = (window.routes && window.routes.cart_url) || "/cart";

  function pathName() {
    var path = window.location.pathname || "/";
    if (path.length > 1 && path.charAt(path.length - 1) === "/") path = path.slice(0, -1);
    return path;
  }

  function onCartPage() {
    return pathName() === "/cart";
  }

  function cartHasItems() {
    var bubble = document.querySelector("#cart-icon-bubble .cart-count-bubble");
    if (!bubble) return false;
    return bubble.textContent.replace(/\s/g, "").length > 0;
  }

  function placeGoCart(wrap) {
    var link = wrap.querySelector(".custom-go-cart");
    if (!link) {
      link = document.createElement("a");
      link.className = "custom-go-cart";
    }
    link.href = cartUrl;
    link.textContent = "מעבר לעגלה";
    var row = wrap.classList.contains("product-form__buttons")
      ? wrap.querySelector(".product-form__quantity-and-btn")
      : null;
    var anchor = row || wrap;
    if (link.parentElement !== anchor) anchor.appendChild(link);
    return link;
  }

  function syncGoCart() {
    var show = !onCartPage() && cartHasItems();
    document.querySelectorAll(".sticky-atc__button, .product-form__buttons").forEach(function (wrap) {
      if (wrap.classList.contains("product-form__buttons") && !wrap.querySelector(".main-product-atc")) return;
      var link = wrap.querySelector(".custom-go-cart");
      if (!show) {
        if (link) link.remove();
        return;
      }
      placeGoCart(wrap);
    });
  }

  function collapseCoupon() {
    document.querySelectorAll("cart-discount-block, .cart-discount").forEach(function (block) {
      if (block.getAttribute("data-code-collapsed") === "true") return;
      var form = block.querySelector("form");
      if (!form) return;
      var toggle = document.createElement("button");
      toggle.type = "button";
      toggle.className = "custom-cart-code-toggle";
      toggle.textContent = "יש לי קוד";
      form.hidden = true;
      toggle.addEventListener("click", function () {
        form.hidden = !form.hidden;
        if (!form.hidden) {
          var input = form.querySelector("input");
          if (input) input.focus();
        }
      });
      block.insertBefore(toggle, form);
      block.setAttribute("data-code-collapsed", "true");
    });
  }

  function removeExtraCheckout() {
    document.querySelectorAll(".cart__dynamic-checkout-buttons, .additional-checkout-buttons, shopify-paypal-button").forEach(function (el) {
      el.remove();
    });
  }

  function stackCartSummary() {
    if (!onCartPage()) return;
    var benefits = document.querySelector(".custom-cart-benefits");
    var host = benefits && benefits.parentElement;
    var footer = document.getElementById("main-cart-footer");
    var pay = host && host.querySelector(".custom-cart-pay-details");
    if (!host || !footer) return;
    if (pay) {
      if (footer.parentElement === host && footer.nextElementSibling === pay) return;
      host.insertBefore(footer, pay);
      return;
    }
    if (footer.parentElement === host) return;
    host.appendChild(footer);
  }

  function growNote() {
    var note = document.getElementById("Cart-note");
    if (!note || note.getAttribute("data-grow") === "true") return;
    note.setAttribute("data-grow", "true");
    note.rows = 1;
    function fit() {
      note.style.height = "2.8rem";
      note.style.height = Math.max(note.scrollHeight, 28) + "px";
    }
    note.addEventListener("input", fit);
    fit();
  }

  function boot() {
    syncGoCart();
    stackCartSummary();
    collapseCoupon();
    removeExtraCheckout();
    growNote();
    if (window.MutationObserver && onCartPage()) {
      var root = document.getElementById("MainContent") || document.body;
      new MutationObserver(function () {
        stackCartSummary();
        collapseCoupon();
        removeExtraCheckout();
        growNote();
      }).observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  var bubble = document.getElementById("cart-icon-bubble");
  if (bubble && window.MutationObserver) {
    new MutationObserver(syncGoCart).observe(bubble, { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener("cartQuantityUpdated", syncGoCart);
  window.addEventListener("resize", syncGoCart);
})();
